import { render, staticRenderFns } from "./zero-self-service.vue?vue&type=template&id=424d655a&"
import script from "./zero-self-service.vue?vue&type=script&lang=js&"
export * from "./zero-self-service.vue?vue&type=script&lang=js&"
import style0 from "./zero-self-service.vue?vue&type=style&index=0&id=424d655a&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('424d655a')) {
      api.createRecord('424d655a', component.options)
    } else {
      api.reload('424d655a', component.options)
    }
    module.hot.accept("./zero-self-service.vue?vue&type=template&id=424d655a&", function () {
      api.rerender('424d655a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/zero-carry-review/zero-self-service.vue"
export default component.exports